module.exports = __webpack_public_path__ + "ath_game_web/img/7.7.1cf46771.png";